import React from 'react';
import { getFeatureFlagValue } from '@citrite/feature-flags';
import { OverlayDrawerComponentProps, PiletApi } from '@sharefiledev/sharefile-appshell';
import { FeatureFlag } from '../featureFlags';

export interface ExtensionProps {
	piral: PiletApi;
}

const LazyCreateProjectOverlayContent = React.lazy(
	() => import('./CreateProjectOverlayContent')
);

const LazyCreateProjectWithTemplateOverlay = React.lazy(
	() => import('./CreateProjectWithTemplateOverlay')
);
export const CreateProjectOverlay: React.FC<
	OverlayDrawerComponentProps<'urn:drawer:projects-pilet:create-project'>
> = props => {
	const isProjectsSolutionEnabled = getFeatureFlagValue(
		FeatureFlag.EnableProjectAsSolution
	);
	if (isProjectsSolutionEnabled) {
		return (
			<React.Suspense
				fallback={<div data-testid="loading-create-project-with-template" />}
			>
				<LazyCreateProjectWithTemplateOverlay
					{...props}
					pendoTrackingNamespace={props?.options?.pendoTrackingNamespace}
				/>
			</React.Suspense>
		);
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-create-project-drawer" />}>
			<LazyCreateProjectOverlayContent
				{...props}
				pendoTrackingNamespace={props?.options?.pendoTrackingNamespace}
			/>
		</React.Suspense>
	);
};

const LazySuggestedProjectsDrawer = React.lazy(
	() => import('./SuggestedProjectsOverlay/SuggestedProjectsDrawer')
);
export const SuggestedProjectsOverlay: React.FC<
	OverlayDrawerComponentProps<'urn:drawer:projects-pilet:suggested-projects'>
> = props => {
	if (!props || !props?.options?.suggestedProjects) {
		return <div data-testid="suggested-projects-drawer-error" />;
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-suggested-projects-drawer" />}>
			<LazySuggestedProjectsDrawer
				suggestedProjects={props.options.suggestedProjects}
				verticalContextKey={props.options.verticalContextKey}
				{...props}
			/>
		</React.Suspense>
	);
};
